import t from '../common/text';

export default (data) => {
    const adviceText = data.adviceText || t('ask.explain');

    return `
    <div class="Form Ask">
      <div class="FormName">Ask</div>
      <div class="Explain">
        ${adviceText}  
      </div>  
      <div class="Message"></div>          
    </div>
  `;
};
